<template>
    <div class="wrapper w-100">
        <div class="loader" :class="{ invisible: loading }">
            <div class="loader-inner">
                <img src="../assets/images/rings.svg" width="60" alt="">
                <p>Chagement...</p>
            </div>
        </div>
        <div class="content">
            <div class="bg">
                <div class="logo">
                    <img src="../assets/images/so.bio.png" alt="" width="300">
                </div>
                <div class="inner" v-if="check">
                    <div class="steps-content">
                        <div v-if="check.data && check.data.client">
                            <span class="step-label">
                                Étape {{currentActive + 1}}
                            </span>
                            <div class="tab-details">
                                <slot :formData="formData" :stepFormUrl="stepFormUrl"></slot>
                            </div>
                            <div class="step-buttons" :class="'step_'+currentActive">
                                <div class="btn-controls d-flex justify-content-center">
                                    <span class="arrow" v-if="currentActive == 0">
                                        <img src="../assets/images/arrow.svg" alt="">
                                    </span>
                                    <div class="control" v-if="currentActive == 0">
                                        <button @click="nextTab()" class="btn btn-primary">Démarrer le questionnaire</button>
                                    </div>
                                    <div class="control" v-if="currentActive < totalTabs - 2 && currentActive > 0">
                                        <button @click="nextTab()" class="btn btn-primary">Suivant</button>
                                    </div>
                                    <div class="control" v-if="currentActive == totalTabs -2" >
                                        <button @click="submit()" class="btn btn-primary">Suivant</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="global-error">
                                <div class="text">
                                    <h1>Erreur</h1>
                                    <p v-if="check && check.data && check.data.message">{{check.data.message}}</p>
                                    <p v-else>Erreur de chargement. Veuillez nous en excuser.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inner-back" v-if="currentActive > 0 && currentActive < totalTabs -1">
                    <a href="javascript:void(0)" @click="previousTab()" class="btn-link d-flex align-item-center">
                        <svg class="rating">
                            <use href="#back-icon" xlink:href="#back-icon" />
                        </svg>    
                        Retour à l'étape {{ currentActive }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import https from 'https';
import axios from 'axios';

export default {
  name: 'form-wizard',
  
  data(){
    return{
        loading: true,
        check: false,
        clientID: false,
        stepFormUrl: false,
        stepFormID: false,
        tabs: [],
        currentActive: 0,
        totalTabs: 0,
        formData:{
            question1: null,
            question2: null,
            question3: null,
            question4: null,
            question5: null,
            question6: null,
            question7: null
        },
        emojiList:[
            'Ne sait pas',
            'Pas du tout satisfait',
            'Pas tellement satisfait',
            'Assez satisfait',
            'Très satisfait'
        ]
    }
   },

    created(){
        this.tabs = this.$children;
        var searchParamsUrl = new URLSearchParams(window.location.search);
        this.stepFormUrl = searchParamsUrl.get('n');
        this.clientID = searchParamsUrl.get('numclt');
    },

    mounted(){

        // this.totalTabs = this.tabs.length;
        this.totalTabs = 7;

        if(this.clientID) {
            // Connect Client First
            var optionAxios = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            var checkClientUrl = 'https://api-nps.sobio.tech/client?client='+this.clientID+'&store=sobio';

            if(this.stepFormUrl) {
                if(this.stepFormUrl >= 1 && this.stepFormUrl <= 10) {
                    this.currentActive = 2;
                    this.formData.question1 = this.stepFormUrl;
                    checkClientUrl += '&init='+this.stepFormUrl;
                }
            }

            axios.get(checkClientUrl, optionAxios).then(response => (
                this.initClient(response)
            )).catch(error => this.check = error);
        }
        else {
            this.check = {
                data: {
                    message: 'Questionnaire non valide'
                }
            };
            this.loading = false;
        }


    },

    methods:{
        initClient(response) {
            this.check = response
            this.stepFormID = response.data.id
            this.loading = false;
        }, 
        previousTab(){
            this.currentActive--;
            this.tabs.forEach(tab => {
                tab.isActive = false;
            });
                this.tabs[this.currentActive].isActive = true;
        },

        nextTab(){
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            //Validate input
            this.$root.$validator.validate('step'+(this.currentActive+ 1)+'.*').then(valid => {
                if (valid){
                    this.currentActive++;
                    this.tabs.forEach(tab => {
                        tab.isActive = false;
                    });
            
                    this.tabs[this.currentActive].isActive = true;
                }
            }); 

        },

        submit(){
            
            this.$root.$validator.validate('step'+(this.currentActive+ 1)+'.*').then(valid => {
                if (valid){

                    this.loading = true;

                    var optionAxios = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }

                    var postDatas = {
                        'formData': this.formData,
                        'formID': false
                    };

                    if(this.stepFormID) {
                        postDatas.formID = this.stepFormID;
                    }

                    axios.post('https://api-nps.sobio.tech/client-response?client='+this.clientID+'&store=sobio', postDatas, optionAxios).then(response => (
                        this.endForm(response)
                    )).catch(error =>  this.endFormError());

                    
                }
            });
        },

        endForm(response) {

            this.loading = false;

            this.currentActive++;
            this.tabs.forEach(tab => {
                tab.isActive = false;
            });
    
            this.tabs[this.currentActive].isActive = true;
            // Redirect
            setTimeout(function() {
                window.location.replace("https://www.sobio.fr/");
            }, 4000);
            
            
        },

        endFormError() {
            alert('Erreur d\'envoi du formulaire. Veuillez nous en excuser');
        }
    }
}
</script>


<style>
</style>